import type { Funnel, FunnelStepName } from './funnel-types';

/** The source, campaign and partner the board shows, kept on every link out of it; the page adds its period. */
function keep(funnel: Funnel, q: URLSearchParams): string {
  if (funnel.source) q.set('source', funnel.source);
  if (funnel.campaign) q.set('campaign', funnel.campaign);
  if (funnel.partner) q.set('partner', funnel.partner);
  return `/admin/funnel?${q.toString()}`;
}

/** Where a step leads: this screen with its companies chosen; visitors are nobody yet. */
export function stepHref(funnel: Funnel, step: FunnelStepName): string | undefined {
  return step === 'visited' ? undefined : keep(funnel, new URLSearchParams({ step }));
}

/** Where a drop-off leads: the companies that got as far as `step` and no further. */
export function stoppedHref(funnel: Funnel, step: FunnelStepName): string | undefined {
  return step === 'visited' ? undefined : keep(funnel, new URLSearchParams({ stopped: step }));
}
